<script setup>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import VariantForm from "@/components/forms/VariantForm.vue";

const store = useStore();
const route = useRoute();

const snippet = computed(() => store.state.currentSnippet);
const variant = computed(() => store.state.currentVariant);

onMounted(async () => {
  await store.dispatch("fetchSnippet", route.params.snippetId);
  await store.dispatch("fetchVariant", route.params.variantId);
});
</script>

<template>
  <div>
    <h1 class="text-4xl font-bold mb-4">
      Edit {{ variant.title }} in {{ snippet.title }}
    </h1>
    <VariantForm />
  </div>
</template>
